import { render, staticRenderFns } from "./WeTalkAboutUs.vue?vue&type=template&id=01216153&"
import script from "./WeTalkAboutUs.vue?vue&type=script&lang=js&"
export * from "./WeTalkAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports